import AdultSymptomExercisePage from '@/components/AdultSymptomExercisePage';
import { isAdultExerciseGroup } from '@/lib/data/contentCatalog';
import { useLocaleStore } from '@/lib/stores/localeStore';
import { createFileRoute } from '@tanstack/react-router';
import ExerciseImage from "@/assets/exercise-background-photos/nightmares.png";
import nightmaresVideoMp4 from '@/assets/videos/adults-symptoms/nightmares/nightmares.mp4';
import nightmaresVideoWebm from '@/assets/videos/adults-symptoms/nightmares/nightmares.webm';
import nightmaresAr from '/subs/nightmares.ar.vtt';
import nightmaresEn from '/subs/nightmares.en.vtt';

export const Route = createFileRoute('/(content)/adults/exercises/nightmares/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    group: isAdultExerciseGroup(search.group) ? search.group : undefined,
    mode: (search.mode === 'videos' || search.mode === 'exercises') ? search.mode as 'videos' | 'exercises' : undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Nightmares - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "exercises.categories.nightmares",
    navbar: {
      transparent: true,
      showTitle: false,
    },
  }),
});

function RouteComponent() {
  const { group, mode } = Route.useSearch();
  const navigate = Route.useNavigate();
  const locale = useLocaleStore((state) => state.locale);
  const captionsDir: 'ltr' | 'rtl' = locale === 'ar' ? 'rtl' : 'ltr';

  const videos = [
    {
      sources: [
        { src: nightmaresVideoWebm, type: 'video/webm' },
        { src: nightmaresVideoMp4, type: 'video/mp4' },
      ],
      videoClassName: "w-full h-full object-contain bg-modal",
      subtitleTracks: [
        { src: nightmaresAr, srcLang: 'ar', label: 'Arabic', default: true },
        { src: nightmaresEn, srcLang: 'en', label: 'English' },
      ],
      activeSubtitleLanguage: locale === 'ar' ? 'ar' : 'en',
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
  ];

  return (
    <AdultSymptomExercisePage
      symptom="nightmares"
      titleKey="exercises.categories.nightmares"
      heroImage={ExerciseImage}
      poster={ExerciseImage}
      videos={videos}
      mode={mode}
      onModeChange={(nextMode) =>
        navigate({
          to: Route.to,
          search: {
            mode: nextMode ?? undefined,
            group: nextMode === 'exercises' ? group : undefined,
          },
        })
      }
      selectedGroup={group}
      onSelectGroup={(nextGroup) =>
        navigate({
          to: Route.to,
          search: { mode: 'exercises', group: nextGroup },
        })
      }
      navButtonColor="text-dark-gray/60"
      skipButtonBgColor="bg-dark-gray/40"
    />
  );
}
